import { Row } from "antd";
import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 24px;
  border-radius: 16px;

  .contractor-card-title {
    line-height: 28px;
    font-size: 20px;
    font-weight: 600;
    color: ${"#434343"};
  }

  .kits-wrapper + .ant-row {
    margin-top: auto;
  }

  .info-text {
    font-weight: 500;
    color: ${"#595959"};
  }

  .contractor-email {
    max-width: 264px;
  }

  .info-element-wrapper > .ant-col:first-child {
    display: flex;
    align-items: center;
  }

  .info-icon > svg {
    height: 16px;
    width: 16px;
    color: ${"#8c8c8c"};
  }

  .edit-icon {
    display: block;

    & > svg {
      height: 24px;
      width: 24px;
      color: ${"#1677ff"};
    }
  }
`;

export const DynamicTagsWrapper = styled(Row)<{ $tagsCount: number }>`
  margin: 4px 0 16px;

  .ant-col .ant-tag {
    display: block;
    height: fit-content;
    margin: 0;
    padding: 2px 8px;
    line-height: 16px;
    font-size: 12px;
    font-weight: 500;
    background-color: ${"#e6f4ff"};
    color: ${"#1677ff"};
  }

  .ant-col {
    max-width: ${(props) => {
      switch (props.$tagsCount) {
        case 1:
          return "100%";

        case 2:
          return "50%";

        case 3:
          return "50%";

        case 4:
          return "50%";

        default:
          return "50%";
      }
    }};
  }

  .ant-col:last-child {
    max-width: ${(props) => {
      switch (props.$tagsCount) {
        case 1:
          return "100%";

        case 2:
          return "50%";

        case 3:
          return "100%";

        case 4:
          return "50%";

        default:
          return "14%";
      }
    }};
  }

  .ant-col:nth-child(3n) {
    max-width: ${(props) => {
      switch (props.$tagsCount) {
        case 3:
          return "100%";

        case 4:
          return "50%";

        default:
          return "43%";
      }
    }};
  }

  .ant-col:nth-child(4n) {
    max-width: ${(props) => {
      switch (props.$tagsCount) {
        case 4:
          return "50%";

        default:
          return "43%";
      }
    }};
  }
`;
